var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"操作日志","width":"750px","visible":_vm.visible,"okText":"确认","destroyOnClose":true},on:{"cancel":_vm.close}},[_c('a-table',{ref:"modalTable",attrs:{"columns":_vm.columns,"data-source":_vm.logList,"scroll":{
      y: '680px'
    },"pagination":false,"loading":_vm.logLoading,"row-key":"id"}}),_c('template',{slot:"footer"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.close}},[_vm._v("关闭")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }